// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../factories/translate-dialog";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import TranslateDialog from "./../factories/translate-dialog";
class Country extends BaseViewModel {
    Country1: KnockoutObservable<string> = ko.observable("");
    Country2: KnockoutObservable<string> = ko.observable("");
    Country3: KnockoutObservable<string> = ko.observable("");
    Country4: KnockoutObservable<string> = ko.observable("");
    Country5: KnockoutObservable<string> = ko.observable("");
    Country = ko.pureComputed({
        read: function () {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Country1();
                case 2:
                    return this.Country2();
                case 3:
                    return this.Country3();
                case 4:
                    return this.Country4();
                case 5:
                    return this.Country5();
            }
        },
        write: function (value) {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Country1(value);
                    break;
                case 2:
                    this.Country2(value);
                    break;
                case 3:
                    this.Country3(value);
                    break;
                case 4:
                    this.Country4(value);
                    break;
                case 5:
                    this.Country5(value);
                    break;
            }
        }
    }, this);
    public constructor(tabPage: TabPage) {
        super(tabPage);
    }
    public InitUrl(): string {
        return "Country/Init";
    }
    public CompleteCheck(): JQueryPromise<boolean> | boolean {
        var completed: boolean;
        completed = true;
        if (Bao.Utils.String.IsNullOrWhitespace(this.Country() as string)) {
            completed = false;
        }
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    public TranslateListName = function () {
        var translateDialog = new TranslateDialog(this.Country1, this.Country2, this.Country3, this.Country4, this.Country5);
        translateDialog.Open().then(function () {
        });
    };
    public init(): JQueryPromise<void> {
        return super.init();
    }
}
export default Country;